import * as Sentry from "@sentry/react";
import { authService } from "../auth/authService";
import { eventBus } from "../event/eventBus";
interface ErrorOptions {
  redirectTo?: string;
  shouldLogout?: boolean;
}

/**
 * Centralized error handling service
 */
export const errorHandler = {
  /**
   * Handle HTTP errors with appropriate notifications and actions
   */
  handleHttpError: (
    statusCode: number,
    options: ErrorOptions = {},
    apiMessage: string = "",
  ) => {
    let message = "Bir hata oluştu. Lütfen tekrar deneyin.";
    let type: "error" | "warning" | "info" = "error";

    // Determine appropriate message based on status code
    switch (statusCode) {
      case 400:
        message = "Geçersiz istek. Lütfen girdiğiniz bilgileri kontrol edin.";
        break;
      case 401:
        message = "Oturum süresi doldu. Lütfen tekrar giriş yapın.";
        // Handle automatic logout
        if (options.shouldLogout !== false) {
          // Clear auth tokens
          authService.clearTokens();
        }
        // Redirect to login page if specified
        if (options.redirectTo) {
          // navigationService.redirect(options.redirectTo);
        }
        break;
      case 403:
        message = "Bu işlem için yetkiniz bulunmuyor.";
        break;
      case 404:
        message = "İstediğiniz kaynak bulunamadı.";
        break;
      case 422:
        message = apiMessage || "İşlem sırasında bir hata oluştu.";
        break;
      case 429:
        message =
          "Çok fazla istek gönderdiniz. Lütfen daha sonra tekrar deneyin.";
        type = "warning";
        break;
      // Server errors
      case 500:
      case 502:
      case 503:
      case 504:
        message = "Sunucu hatası. Lütfen daha sonra tekrar deneyin.";
        break;
    }

    // Report server errors (5xx) to Sentry
    if (statusCode >= 500) {
      Sentry.captureException(
        new Error(`HTTP ${statusCode}: ${apiMessage || message}`),
        { tags: { errorType: "http", statusCode: statusCode.toString() } },
      );
    }

    // Show notification
    eventBus.emit("notify", { message, type });

    return message;
  },

  /**
   * Handle network or unexpected errors
   */
  handleNetworkError: (error: Error) => {
    // Network connectivity issues
    if (
      error.message.includes("NetworkError") ||
      error.message.includes("Failed to fetch")
    ) {
      eventBus.emit("notify", {
        message: "Bağlantı hatası. İnternet bağlantınızı kontrol edin.",
        type: "error",
      });
      return;
    }

    // Generic error handling
    eventBus.emit("notify", {
      message: "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.",
      type: "error",
    });

    Sentry.captureException(error);
  },
};
